<div class="card risk-contribution-chart h-100">
  <div class="card-body">
    <div class="card-head">
      <div class="card-title">
        Risk contribution and allocation
        <app-info infoIndex="9"></app-info>
      </div>
    </div>
    @if (!loaded()) {
      <app-chart-placeholder></app-chart-placeholder>
    }
    @if (loaded()) {
      <highcharts-chart
        [options]="chartOptions"
        style="width: 100%; height: auto; display: block"
      ></highcharts-chart>
    }
  </div>
</div>
